import {
  IRoute, IArguments,
  Routes as RouteDefinitions
}              from 'Config/Routes';
import isEmpty from 'lodash/isEmpty';

export type ISideboardEntry = IRoute & { key: string, sorting: number, label: string, icon?: string };

class LinkHandler {

  _routes: Record<string, IRoute & { key: string }> = {};

  constructor() {
    Object.keys(RouteDefinitions).forEach((key) => {
      this._routes[key] = this.convertRouteByKey(key);
      this.getChildrenRoutes(RouteDefinitions[key], this._routes);
    });
  }

  get(routeKey: string, args: IArguments = {}, internal = true) {
    const route: IRoute = this._routes[routeKey];
    if (!internal || !route) {
      return routeKey;
    }

    return this.getUrlWithArguments(route.path, args, route);
  }

  getUrlWithArguments(path: string, args: IArguments = {}, route: IRoute | null = null): string {
    if (route !== null) {
      if (!isEmpty(args) && route.arguments) {
        (route?.arguments || []).forEach((argument: string) => {
          if (!args[argument]) {
            console.warn(`the route expected the following argument: ${argument}`);
            return null;
          }
          path += `/${args[argument]}`;
        });
      }
    }

    for (const key in args) {
      const value = args[key];
      if (path.match(`:${key}`)) {
        path = path.replace(`:${key}`, `${value || ''}`);
      }
    }

    return path;
  }

  getPrivateRoutes() {
    return Object.values(RouteDefinitions).filter((route: IRoute) => route.private);
  }

  convertRouteByKey(key: string) {
    const route = this._routes[key] || RouteDefinitions[key];

    return Object.assign({},
      { ...route },
      { key },
      { ...route.sidebar },
      { sorting: (route.sidebar && route.sidebar.sorting) ? route.sidebar.sorting : 1000 },
    );
  }

  getSideBoard() {
    const sideBoard: ISideboardEntry[] = [];

    for (const key in RouteDefinitions) {
      const route = RouteDefinitions[key];

      if (route.hasOwnProperty('sidebar')) {
        sideBoard.push(this.convertRouteByKey(key));
      }
    }

    const orderSideBar = (a: any, b: any) =>
      (a.sorting > b.sorting) ? 1 : ((b.sorting > a.sorting) ? -1 : 0);

    return sideBoard.sort(orderSideBar);
  }

  getChildrenRoutes(route: IRoute, acc: Record<string, IRoute & { key: string }> = {}) {
    if (!route.children) {
      return acc;
    }

    for (const key in route.children) {
      if (key in acc) {
        throw new Error(`Route key ${key} already exists`);
      }
      acc[key] = {
        private: route?.private || route.children[key]?.private,
        ...route.children[key],
        key,
        children: route.children[key].children || undefined,
        path: `${route.path}${route.children[key].path}`,
      };
      this.getChildrenRoutes(acc[key], acc);
    }
    return acc;
  }

  getAllRoutes(): Record<string, IRoute & { key: string }> {
    return this._routes;
  }

}

export const linkHandler = new LinkHandler();
